import React, { useEffect } from 'react';

// Lightweight modal component
const Modal = ({ title, onClose, children }) => {
    // Close on ESC
    useEffect(() => {
      const handler = (e) => {
        if (e.key === 'Escape') onClose();
      };
      window.addEventListener('keydown', handler);
      return () => window.removeEventListener('keydown', handler);
    }, [onClose]);
  
    // Prevent background scroll while open
    useEffect(() => {
      const original = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = original;
      };
    }, []);
  
    const onBackdropClick = (e) => {
      if (e.target === e.currentTarget) onClose();
    };
  
    return (
      <div
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={onBackdropClick}
        style={{
          position: 'fixed',
          inset: 0,
          background: 'rgba(0,0,0,0.4)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
        }}
      >
        <div
          style={{
            background: '#fff',
            borderRadius: 10,
            minWidth: 320,
            maxWidth: '90vw',
            padding: 16,
            boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
            <h3 style={{ margin: 0 }}>{title}</h3>
            <button
              onClick={onClose}
              aria-label="Close"
              style={{
                background: 'transparent',
                border: 'none',
                fontSize: 22,
                lineHeight: 1,
                cursor: 'pointer',
              }}
            >
              ×
            </button>
          </div>
          <div style={{ marginTop: 12 }}>
            {children /* empty body for now */}
          </div>
        </div>
      </div>
    );
  };

  export { Modal };